var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block","width":"100%","height":"100%","background-color":"#eee"}},[_c('live_view_l',{attrs:{"name":"l1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }